const currencySelector = {
  currencyList: state => state.currencyReducer.currency,
  symbol: state => state.currencyReducer.selectedCurrency.symbol,
  rate: state => state.currencyReducer.selectedCurrency.conversionRate,
  currency: state => state.currencyReducer.selectedCurrency.name
}

export default currencySelector
